import React from 'react';
import Lottie from 'react-lottie-player';
import loaderAnimation from '@assets/images/sl-calculating-loader.json'; 

export interface CalculatingLoaderProps{
  size?:string;
  className?: string;
}
function CalculatingLoader({size="40px",className,...props}:CalculatingLoaderProps) {
  
  return (
    <Lottie className={className} loop={true} animationData={loaderAnimation} play={true} style={{ width: size, height: size }}></Lottie>        
  )
}

export default CalculatingLoader